import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {PatchUpdatePhone, PatchUpdatePhoneResponse, PostConfirmPhoneParams} from 'domain/usecases';

export class RemotePatchUpdatePhone implements PatchUpdatePhone {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PatchUpdatePhoneResponse>,
	) {}

	async patch(params: PostConfirmPhoneParams): Promise<PatchUpdatePhoneResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
